import axios from "axios";
import { Config } from "../env";

const api = axios.create({
  baseURL: Config.API_S4DIGITAL,
});

export default api;
